export default ({ player, isp, bestIsp }) => {
  if (!player || !isp || !bestIsp || !player.stats_overall || !isp.stats_ethernet || !bestIsp.stats_ethernet) {
    return false
  }

  return player.stats_overall.connection_score <= (isp.stats_ethernet.connection_score - 5) || isp.stats_ethernet.connection_score <= (bestIsp.stats_ethernet.connection_score - 5)
}



// WEBPACK FOOTER //
// ./src/utils/show_notification.js